/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2022 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { AppState } from "src/store";

export function reduxSanitizer(state: AppState): any {
  return state;
}
